//import { IconButton } from '@mui/material';
import { Box, Container, Grid } from '@mui/material';
import logorheinland from '../../rheinland.svg';
import { AppState, DefaultProps, HeaderLayout } from '../../types/types';
//import LogoutIcon from '@mui/icons-material/Logout';
//import LinkedappBackend from '../../services/LinkedappBackend';
import BrokerInfo from './BrokerInfo';


interface HeaderProps extends DefaultProps {
    appState: AppState,
}

function getHeaderContent(props: HeaderProps) {
    let postfix: string = props.appState?.customizingId || 'rl';
    let tenantlogo = props.appState?.customizing?.logoSrc != null ? <img src={props.appState?.customizing?.logoSrc || logorheinland} className={"logo logo-" + postfix} alt="Logo" /> : '';

    /*
    let logout = () => {
        window.location.href = LinkedappBackend.logout(); 
    }
*/


    return (

        <Grid container spacing={0} className="container">
            <Grid item xs={9} md={6} className="header-container" sx={{ display: 'flex', justifyContent: 'left', textAlign: 'left' }}>
                <span className="vertical-align-helper"></span>
                {tenantlogo}

            </Grid>
            <Grid item xs={3} md={6} className="header-container" sx={{ display: 'flex', justifyContent: 'right', textAlign: 'right' }}>
                <Grid sx={{ display: { sx: "none", xs: "none", md: "flex", lg: "flex" }}}>
                    <BrokerInfo appState={props.appState} ></BrokerInfo>
                </Grid>
                <Grid sx={{ display: { sx: "flex", xs: "flex", md: "none", lg: "none" }}}>
                <Grid  xs={10} md={10}  sx={{ display: { sx: "flex", xs: "flex", md: "none", lg: "none" }}}>
                    <BrokerInfo appState={props.appState} ></BrokerInfo>
                </Grid>
                </Grid>
            </Grid>

        


        </Grid>

    );
}

function Header(props: HeaderProps) {
    const content = getHeaderContent(props);
    return (
        <Box className="header" sx={{ backgroundColor: 'header.main' || '#fafafa', color: 'header.contrastText' || '#009767' }}>
            {HeaderLayout[HeaderLayout.EMBEDDED_IN_CONTAINER] === HeaderLayout[props.appState.customizing.headerLayout] ? <>{content}</> : <Container maxWidth="lg">{content}</Container>}
        </Box>
    );
}
export default Header;